import { Component } from '@angular/core';

// noinspection AngularMissingOrInvalidDeclarationInModule
@Component({
  template: '',
  // tslint:disable-next-line:no-host-metadata-property
  host: { class: 'page-block container-fluid' },
})
export class PageBlockComponent {}

// noinspection AngularMissingOrInvalidDeclarationInModule
@Component({
  template: '',
  // tslint:disable-next-line:no-host-metadata-property
  host: { class: 'page-block container' },
})
export class PageBlockContainerComponent {}
